module.exports = __webpack_public_path__ + "static/don39-00c8e7dc63ae126ccd2b7da9f0c84ebd.jpg";